export const isStaging = () =>
  typeof window !== "undefined"
    ? window.location.hostname.includes("privacy-horizon-staging")
    : false;

export const isLocal = () =>
  typeof window !== "undefined"
    ? window.location.hostname.includes("localhost")
    : false;
